import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classes from './pricing.module.css';
import Header from '../../components/standartComponents/header';
import axios from 'axios';
import { getCSRFToken } from '../../lib/csrf';

const Pricing = ({ authUser }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [bill, setBill] = useState('m');
  // NOTE: Yearly billing toggle is hidden until backend supports annual plans
  // const [bill, setBill] = useState('m');
  const [bzModal, setBzModal] = useState(false);
  const [bzOk, setBzOk] = useState(false);
  
  const [plans, setPlans] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axios.get('/api/billing/plans/', {
          withCredentials: true,
        });
        setPlans(response.data);
      } catch (error) {
        console.error('Error fetching plans:', error);
      }
    };
    fetchPlans();
  }, []);

  const handlePayment = async (productId) => {
    // If not authenticated, redirect to sign in
    if (!authUser?.isAuthenticated) {
      navigate('/signin');
      return;
    }

    setIsProcessing(true);
    try {
      const pid = productId || (premiumPlan ? premiumPlan.id : 1);
      
      const csrfToken = getCSRFToken();
      console.log('Creating subscription with product_id:', pid);
      
      const response = await axios.post('/api/billing/subscription/create/', {
        product_id: parseInt(pid)
      }, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          ...(csrfToken && { 'X-CSRFToken': csrfToken })
        }
      });
      
      console.log('Subscription created:', response.data);
      
      if (response.data.page_url) {
        console.log('Redirecting to Monobank:', response.data.page_url);
        window.location.href = response.data.page_url;
      } else {
        console.error('No page_url in response');
        setIsProcessing(false);
      }
    } catch (error) {
      console.error('Error creating subscription:', error);
      setIsProcessing(false);
      alert(t('Something went wrong. Please try again.'));
    }
  };

  const [faqOpen, setFaqOpen] = useState(null);

  const toggleFaq = (idx) => {
    setFaqOpen(faqOpen === idx ? null : idx);
  };

  const openBiz = () => {
    setBzOk(false);
    setBzModal(true);
  };

  // Check if it's a renewal (Design 13) or first purchase (Design 12)
  const isRenewal = authUser?.subscriptionType === 'premium' || authUser?.hasHadSubscription;

  const premiumPlan = plans.find(p => p.name.includes('Преміум') || p.name.includes('Premium'));
  const monthlyPrice = premiumPlan ? parseFloat(premiumPlan.price) : 299;
  // NOTE: Yearly pricing hidden until backend supports annual plans
  // const yearlyPrice = premiumPlan ? (monthlyPrice * 10) : 2988;
  // const yearlyPricePerMonth = premiumPlan ? Math.round(yearlyPrice / 12) : 249;
  // const saveAmount = (monthlyPrice * 12) - yearlyPrice;

  return (
    <>
      <Header authUser={authUser} isPricing={true} />
      <div className={classes.wrap}>
        {/* HERO */}
        <div className={classes.hero}>
          <div className={classes.badge}><span className={classes.badgeDot}>✦</span>{isRenewal ? t('pricing.renewalBadge', 'Продовжіть навчання') : t('Plans tailored to your needs')}</div>
          <h1>{isRenewal ? t('pricing.renewalTitle', 'Поновіть вашу підписку') : t("Choose your learning plan")}</h1>
          <p>{isRenewal ? t('pricing.renewalDesc', 'Залишайтеся з нами та продовжуйте досягати нових вершин у вивченні англійської.') : t("Start for free, unlock full access to lessons, or choose AI Lingua for your team.")}</p>
          {/* Billing toggle hidden — backend only supports monthly plans for now
          <div className={classes.toggleRow}>
            <div className={classes.toggle}>
              <button className={bill === 'm' ? classes.on : ''} onClick={() => setBill('m')}>{t("Monthly")}</button>
              <button className={bill === 'y' ? classes.on : ''} onClick={() => setBill('y')}>{t("Yearly")}</button>
            </div>
            <span className={`${classes.saveTag} ${bill === 'y' ? classes.show : ''}`}>−17% вигідніше</span>
          </div>
          */}
        </div>

        {/* PRICING CARDS */}
        <div className={classes.cards}>
          
          {/* FREE */}
          <div className={classes.plan}>
            <div className={classes.planName}>{t("Free")}</div>
            <div className={classes.planSub}>{t("To try the platform")}</div>
            <div className={classes.planPrice}>0 <span className={classes.sm}>{t("UAH")}</span></div>
            <div className={classes.planBill}>{t("free forever")}</div>
            <ul className={classes.feats}>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("2-minute trial lesson")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Limited access to video lessons")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Add words to dictionary")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Basic progress saving")}</li>
              <li className={classes.featOff}><svg className={classes.fn} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>{t("AI Speaking — limited")}</li>
              <li className={classes.featOff}><svg className={classes.fn} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>{t("Personal plan — unavailable")}</li>
              <li className={classes.featOff}><svg className={classes.fn} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>{t("Full catalog — unavailable")}</li>
            </ul>
            <button className={`${classes.pcta} ${classes.pctaG}`} onClick={() => navigate(authUser?.isAuthenticated ? '/survey' : '/signup')}>{t("Start for free")}</button>
          </div>

          {/* PREMIUM */}
          <div className={`${classes.plan} ${classes.prem}`}>
            <span className={classes.pbadge}>★ {t("Most popular")}</span>
            <div className={classes.planName}>{t("Premium")}</div>
            <div className={classes.planSub}>{t("For individual learning")}</div>
            <div className={classes.planPrice}>
              {monthlyPrice} <span className={classes.sm}>{t("UAH / month")}</span>
            </div>
            <div className={classes.planBill}>
              {t("billed monthly")}
            </div>
            <ul className={classes.feats}>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Personal learning plan")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("All video lessons")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{`${t("Video")} → ${t("Words")} → ${t("Quiz")} → ${t("Speaking")}`}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("AI dialogue practice")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Personal dictionary")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Progress saving")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Review completed lessons")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Self-study without a plan")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Saved videos and statistics")}</li>
            </ul>
            <button className={`${classes.pcta} ${classes.pctaP}`} onClick={() => handlePayment()} disabled={isProcessing}>
              {isProcessing ? 'Обробка...' : (isRenewal ? `${t('Renew subscription')} →` : `${t('Subscribe')} →`)} 
            </button>
          </div>

          {/* BUSINESS */}
          <div className={classes.plan}>
            <div className={classes.planName}>{t("Business")}</div>
            <div className={classes.planSub}>{t("For companies, schools, and universities")}</div>
            <div className={classes.planPrice} style={{fontSize: '22px'}}>{t("Custom pricing")}</div>
            <div className={classes.planBill}>{t("tailored to your team's needs")}</div>
            <ul className={classes.feats}>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("All Premium features")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Access for a group of users")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Each learner's progress")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Admin reports")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Learning tailored to company goals")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Dedicated manager support")}</li>
              <li><svg className={classes.fy} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Volume discounts")}</li>
            </ul>
            <button className={`${classes.pcta} ${classes.pctaO}`} onClick={openBiz}>{t("Contact us")} →</button>
          </div>

        </div>

        {/* COMPARISON TABLE */}
        <div className={classes.cmp}>
          <h2>{t("Plan comparison")}</h2>
          <table>
            <thead><tr><th>{t("Feature")}</th><th>{t("Free")}</th><th className={classes.hl}>{t("Premium")}</th><th>{t("Business")}</th></tr></thead>
            <tbody>
              <tr><td>{t("Trial Lesson")}</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("All video lessons")}</td><td className={classes.cp}>{t("limited")}</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("Personal Plan")}</td><td className={classes.cx}>—</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("AI Speaking")}</td><td className={classes.cp}>{t("limited")}</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("Personal dictionary")}</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("Learning Progress")}</td><td className={classes.cp}>{t("basic")}</td><td className={classes.ck}>✓</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("Group access")}</td><td className={classes.cx}>—</td><td className={classes.cx}>—</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("Admin reports")}</td><td className={classes.cx}>—</td><td className={classes.cx}>—</td><td className={classes.ck}>✓</td></tr>
              <tr><td>{t("Dedicated manager support")}</td><td className={classes.cx}>—</td><td className={classes.cx}>—</td><td className={classes.ck}>✓</td></tr>
            </tbody>
          </table>
        </div>

        {/* FAQ */}
        <div className={classes.faq}>
          <h2>{t("Frequently asked questions")}</h2>
          <div className={classes.faqList}>
            <div className={`${classes.faqItem} ${faqOpen === 0 ? classes.open : ''}`}>
              <div className={classes.fq} onClick={() => toggleFaq(0)}>{t("Can I start for free?")}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg></div>
              <div className={classes.fa}><div className={classes.faInner}>{t("Yes. You can try the platform for free and take a trial lesson. Registration does not require payment.")}</div></div>
            </div>
            <div className={`${classes.faqItem} ${faqOpen === 1 ? classes.open : ''}`}>
              <div className={classes.fq} onClick={() => toggleFaq(1)}>{t("What is included in Premium?")}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg></div>
              <div className={classes.fa}><div className={classes.faInner}>{t("Premium includes a personal plan, all video lessons, AI speaking practice, a dictionary, progress saving, and detailed learning statistics.")}</div></div>
            </div>
            <div className={`${classes.faqItem} ${faqOpen === 2 ? classes.open : ''}`}>
              <div className={classes.fq} onClick={() => toggleFaq(2)}>{t("Can I cancel my subscription?")}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg></div>
              <div className={classes.fa}><div className={classes.faInner}>{t("Yes. You can cancel your subscription at any time in your account. Access will remain active until the end of the paid period.")}</div></div>
            </div>
            <div className={`${classes.faqItem} ${faqOpen === 3 ? classes.open : ''}`}>
              <div className={classes.fq} onClick={() => toggleFaq(3)}>{t("What is Business?")}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg></div>
              <div className={classes.fa}><div className={classes.faInner}>{t("Business offers custom terms for companies, schools, and universities, including group access, reports, and dedicated manager support.")}</div></div>
            </div>
            <div className={`${classes.faqItem} ${faqOpen === 4 ? classes.open : ''}`}>
              <div className={classes.fq} onClick={() => toggleFaq(4)}>{t("Will my progress be saved after changing plans?")}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg></div>
              <div className={classes.fa}><div className={classes.faInner}>{t("Yes. Your progress is saved in your account regardless of your plan.")}</div></div>
            </div>
          </div>
        </div>

      </div>

      {/* FOOTER */}
      <div className={classes.foot}>
        <div className={classes.footIn}>
          <div className={classes.footC}>© 2026 AI Lingua. {t("All rights reserved")}.</div>
          <div className={classes.footL}>
            <a href="tel:+380682507477">+380682507477</a>
            <Link to="/termsOfUse">{t("Terms of Use")}</Link>
            <Link to="/privacy">{t("Privacy Policy")}</Link>
            <Link to="/cancelAndRefund">{t("Cookie Settings")}</Link>
          </div>
        </div>
      </div>



      {/* BUSINESS MODAL */}
      <div className={`${classes.ov} ${bzModal ? classes.show : ''}`} onClick={() => setBzModal(false)}>
        <div className={classes.mod} onClick={e => e.stopPropagation()}>
          {!bzOk ? (
            <div>
              <div className={classes.modT}>Отримати пропозицію для команди</div>
              <div className={classes.modS}>Залиште контактні дані, і ми зв'яжемося з вами.</div>
              <div className={classes.fr}><div className={classes.fg}><label className={classes.fl}>Ім'я</label><input className={classes.fi} placeholder="Ваше ім'я" /></div><div className={classes.fg}><label className={classes.fl}>Email</label><input className={classes.fi} type="email" placeholder="email@company.com" /></div></div>
              <div className={classes.fr}><div className={classes.fg}><label className={classes.fl}>Компанія</label><input className={classes.fi} placeholder="Назва" /></div><div className={classes.fg}><label className={classes.fl}>Кількість користувачів</label><input className={classes.fi} type="number" placeholder="10" /></div></div>
              <div className={classes.fg}><label className={classes.fl}>Повідомлення</label><textarea className={classes.fi} placeholder="Розкажіть про потреби (необов'язково)" style={{resize: 'vertical', minHeight: '60px'}}></textarea></div>
              <div className={classes.mbtn}>
                <button className={classes.mc} onClick={() => setBzModal(false)}>Скасувати</button>
                <button className={classes.ms} onClick={() => setBzOk(true)}>Надіслати заявку</button>
              </div>
            </div>
          ) : (
            <div>
              <div className={classes.suc}>
                <div className={classes.sucIc}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg></div>
                <div className={classes.sucT}>Дякуємо!</div>
                <div className={classes.sucS}>Ми зв'яжемося з вами найближчим часом.</div>
              </div>
              <div style={{textAlign: 'center'}}><button className={classes.ms} onClick={() => setBzModal(false)} style={{width: 'auto', padding: '12px 32px'}}>Закрити</button></div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Pricing;